export default "skymp5-front/611ee0dba6d1e4b651d190253b3b28f6.png";